import "./wdyr";
import "./index.css";

import * as Sentry from "@sentry/react";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import { SENTRY } from "./utils/constants";
import { ServiceWorkerUpdateAvailable } from "./components/ServiceWorkerUpdateAvailable";
import packageJson from "../package.json";
import { store } from "./redux/redux";
import "./utils/otplessInitializer";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: SENTRY.DSN,
    tracesSampleRate: SENTRY.SAMPLE_RATE,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    environment: process.env.NODE_ENV,
    replaysOnErrorSampleRate: 1,
    replaysSessionSampleRate: 0.3,
    autoSessionTracking: true,
    ignoreErrors: [/SyntaxError: JSON Parse error: Unterminated string/], // ignore blitz sdk internal parsing error
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"), {
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

const serviceWorkerModalRoot = ReactDOM.createRoot(
  document.getElementById("service-worker-modal-root")
);

const render = () => {
  root.render(
    <Provider store={store}>
      <ParallaxProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ParallaxProvider>
    </Provider>
  );
};

const ServiceWorkerModal = () => {
  serviceWorkerModalRoot.render(<ServiceWorkerUpdateAvailable />);
};
ServiceWorkerModal();

window.customCopy = (text, navigator) => {
  if (window.ReactNativeWebView) {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({ type: "copy", payload: text })
    );
  } else {
    navigator?.clipboard?.writeText(text);
  }
};

window.customPaste = (pasteFunction, navigator) => {
  if (window?.ReactNativeWebView) {
    const obj = JSON.parse(window?.ReactNativeWebView?.injectedObjectJson());
    if (obj?.appBuild > 5) {
      // only release this feature for new app release for both platform
      window?.ReactNativeWebView?.postMessage(
        JSON.stringify({ type: "paste" })
      );
      if (obj?.platform === "android") {
        document.addEventListener("message", (e) => {
          try {
            const response = JSON.parse(e.data);
            pasteFunction(response?.payload || "");
          } catch (error) {
            // eslint-disable-next-line
          }
        });
      } else {
        window.addEventListener("message", (e) => {
          if (!e?.data) return;
          try {
            const response = JSON.parse(e.data);
            if (response && typeof response === "object") {
              pasteFunction(response?.payload || "");
            }
          } catch (error) {
            console.error(
              "Failed to parse message data :: ios :: paste :",
              error
            );
          }
        });
      }
    } else if (obj?.platform === "android" && obj?.clipboard) {
      pasteFunction(obj?.clipboard);
    }
  } else {
    navigator?.clipboard?.readText()?.then(pasteFunction);
  }
};
window.customShare = (text, navigator) => navigator?.share({ text: text });

render();

function registerServiceWorker() {
  serviceWorkerRegistration.register({
    onSuccess: () => {
      console.log("Service Worker registered successfully");
    },
    onUpdate: (registration) => {
      console.log("update avaliable");
    },
  });
}

// Call this function where appropriate in your app initialization
if (window?.ReactNativeWebView) {
  registerServiceWorker();
}
// this part is for Hotupdate where i want user to be on the latest version.

const SW_CHANNEL_NAME = "service-worker-channel";

const channel =
  typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel(SW_CHANNEL_NAME)
    : { postMessage: () => {} };

channel?.addEventListener("message", (event) => {
  const type = event?.data?.type;
  const hotUpdateVersion = event?.data?.data?.hotUpdateVersion;
  const compareSemver = (v1, v2) => {
    const normalize = (v) => v.split(".").map(Number);
    const [major1, minor1, patch1] = normalize(v1);
    const [major2, minor2, patch2] = normalize(v2);

    if (major1 !== major2) return major1 - major2;
    if (minor1 !== minor2) return minor1 - minor2;
    return patch1 - patch2;
  };
  const packageVersion = packageJson?.version;
  if (
    type === "SERVICE_WORKER_VERSION" &&
    compareSemver(hotUpdateVersion, packageVersion) > 0
  ) {
    const div = document.getElementById("service-worker-modal-root");
    if (event.data.data.status === "activated") {
      div.style.display = "block";
    }
  }
});
